import React from 'react';
import SvgIcon from './svg-icon.jsx';

export default function MessageTemplateIcon({
  active = false,
  arrow = false,
  className = '',
  size = 24,
  title,
  ...props
}) {
  if (arrow) {
    // No explicit width/height attributes here: old iOS Safari (13.x) fails to render this
    // <use> when the <svg> has explicit width/height that don't match its CSS box (see
    // .message-template-arrow, which is a different, non-square size). Sizing is CSS-only,
    // same as .icon-close elsewhere in this file.
    return (
      <SvgIcon
        name="compose-arrow"
        viewBox="0 0 9 15"
        className={['message-template-arrow', 'compose-action-icon', className].filter(Boolean).join(' ')}
        title={title}
        {...props}
      />
    );
  }

  const classNames = [
    'message-template-icon',
    'compose-action-icon',
    active ? 'message-template-icon-active' : 'message-template-icon-inactive',
    className,
  ].filter(Boolean).join(' ');

  return (
    <SvgIcon
      name={active ? 'message-template-active' : 'message-template-inactive'}
      viewBox="0 0 20 20"
      size={size}
      className={classNames}
      title={title}
      {...props}
    />
  );
}
